import type { TourStep } from '@/components/ui/Tour';
import type { PageTourKey } from './registry';
import {
  type AcademySettingsTourOptions,
  getAcademySettingsTourSteps,
} from './academy-settings-tour-steps';
import { schedulePageTourStart } from './scheduleAutoPageTour';

export type { AcademySettingsTourOptions };

export const ACADEMY_SETTINGS_TOUR_KEY: PageTourKey = 'academy-settings';

export function scheduleAcademySettingsTourStart(
  startTourWithCompletionKey: (completionKey: string, steps: TourStep[]) => void,
  options: AcademySettingsTourOptions = {},
): () => void {
  return schedulePageTourStart(
    () =>
      startTourWithCompletionKey(ACADEMY_SETTINGS_TOUR_KEY, getAcademySettingsTourSteps(options)),
    ACADEMY_SETTINGS_TOUR_KEY,
  );
}
